import React from "react";
import { CardFrame } from "../card-frame/CardFrame";
import styles from "./IconRadioGroup.module.scss";

export interface IconRadioOption {
	title: string;
	subtitle?: string;
	icon: React.ReactNode;
}

interface Props {
	options: IconRadioOption[];
	selectedIndex: number | null;
	onOptionSelected: (index: number) => void;
	headerTitle?: string;
	headerRightContent?: React.ReactNode;
	iconSize?: number;
}

export const IconRadioGroup = ({ options, selectedIndex, onOptionSelected, headerTitle, headerRightContent, iconSize = 28 }: Props) => {
	return (
		<CardFrame headerSectionTitle={headerTitle} headerSectionRightContent={headerRightContent} paddingBottom={0}>
			<div className={styles.optionsList}>
				{options.map((option, index) => {
					const isSelected = selectedIndex === index;
					// const IconComponent = option.icon;

					return (
						<button
							key={index}
							type="button"
							className={`${styles.option} ${isSelected ? styles.optionSelected : ""}`}
							onClick={() => onOptionSelected(index)}
						>
							<div className={`${styles.iconCircle} ${isSelected ? styles.iconCircleSelected : styles.iconCircleDefault}`}>
								{option.icon}
							</div>
							<div className={styles.textContent}>
								<span className={`${styles.title} ${isSelected ? styles.titleSelected : ""}`}>{option.title}</span>
								{option.subtitle && <span className={styles.subtitle}>{option.subtitle}</span>}
							</div>
							<div className={`${styles.radio} ${isSelected ? styles.radioSelected : ""}`}>
								{isSelected && <div className={styles.radioDot} />}
							</div>
						</button>
					);
				})}
			</div>
		</CardFrame>
	);
};
